// Temporary passwords offered in the new user form. They are generated in the
// browser from the Web Crypto API so that no default password is ever shipped
// in the site's code. Like the admin service's generator, they leave out I, l,
// 1, O and 0, which are easily confused when a password is read and typed.
const UPPER = "ABCDEFGHJKLMNPQRSTUVWXYZ";
const LOWER = "abcdefghijkmnopqrstuvwxyz";
const DIGITS = "23456789";
const SYMBOLS = "#@-=_+^*";
const ALPHABET = UPPER + LOWER + DIGITS + SYMBOLS;

// Matches the Cognito pool's policy and the form's own validation
export const MINIMUM_PASSWORD_LENGTH = 16;
export const TEMPORARY_PASSWORD_LENGTH = 20;

const browserRandomValues = (array) => window.crypto.getRandomValues(array);

// A uniformly distributed index below n, rejecting values that would bias the
// result towards the start of the alphabet.
export const randomIndex = (n, getRandomValues) => {
  const limit = Math.floor(0x100000000 / n) * n;
  const buffer = new Uint32Array(1);
  do {
    getRandomValues(buffer);
  } while (buffer[0] >= limit);
  return buffer[0] % n;
};

const hasCharFrom = (password, chars) =>
  [...password].some((c) => chars.includes(c));

export const validatePassword = (password) => {
  if (!password) return "Password is required";
  if (password.length < MINIMUM_PASSWORD_LENGTH)
    return `Password must be at least ${MINIMUM_PASSWORD_LENGTH} characters long`;
  if (!/[a-z]/.test(password))
    return "Password must have at least one lowercase letter";
  if (!/[A-Z]/.test(password))
    return "Password must have at least one uppercase letter";
  if (!/[0-9]/.test(password)) return "Password must contain a number";
  return null;
};

export const generateTemporaryPassword = (
  length = TEMPORARY_PASSWORD_LENGTH,
  getRandomValues = browserRandomValues
) => {
  if (length < MINIMUM_PASSWORD_LENGTH) {
    throw new Error(
      `Passwords must be at least ${MINIMUM_PASSWORD_LENGTH} characters long`
    );
  }
  let password = "";
  while (
    !hasCharFrom(password, UPPER) ||
    !hasCharFrom(password, LOWER) ||
    !hasCharFrom(password, DIGITS) ||
    !hasCharFrom(password, SYMBOLS)
  ) {
    password = "";
    for (let i = 0; i < length; i++) {
      password += ALPHABET[randomIndex(ALPHABET.length, getRandomValues)];
    }
  }
  return password;
};
